import {styled} from "@mui/material/styles";
import MuiToggleButton from "@mui/material/ToggleButton";
import MuiToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import {makeStyles} from "@mui/styles";
import {renderToStaticMarkup} from "react-dom/server";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary, {accordionSummaryClasses} from "@mui/material/AccordionSummary";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import {Avatar, Box, Button, Checkbox, Collapse, Dialog, DialogContent, Grid, IconButton, InputAdornment, InputBase, ListSubheader, Menu, MenuItem, Select, Slider, Snackbar, Stack, TextField, Tooltip, Typography} from "@mui/material";
import {DatePicker, TimePicker} from "@mui/x-date-pickers";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {ReactElement, useEffect, useMemo, useRef, useState} from 'react';
import ClearIcon from "@mui/icons-material/Clear";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import PropTypes from "prop-types";
import StepConnector, {stepConnectorClasses} from "@mui/material/StepConnector";
import {Cancel, CheckOutlined, Close, ExpandLess, ExpandMore, Search} from "@mui/icons-material";
import {PrimaryColor} from "../component/theme/theme";

export const ToggleButton = styled(MuiToggleButton)({
    "&": {
        borderRadius: "8px",
        textTransform: "none",
        height: "35px",
        fontSize: "14px",
        width: "116px",
        border: "0 !important",
        background: "#3a3e3f",
        color: "#ffffff",
    },

    "&.Mui-selected": {
        backgroundColor: "#ffc540",
        color: "#3a3e3f",
        fontWeight: "normal",        // <-- force non-bold
        border: "1px solid #000",
    },

    "&&:hover": {
        backgroundColor: "#3a3e3f !important",
        color: "#ffffff !important",
    },

    "&&.Mui-selected:hover": {
        backgroundColor: "#ffc540 !important",
        color: "#3a3e3f !important",
    },
    "&&.Mui-disabled": {
        color: "#686868 !important",
    },
    "&&.Mui-disabled.Mui-selected": {
        color: "#686868 !important",
    },
});

export const ToggleButtonPill = styled(MuiToggleButton)({
    "&.MuiToggleButton-root": {
        borderRadius: "0px",
        textTransform: "none",
        height: "40px",
        fontSize: "14px",
        fontWeight: 600,
        background: "transparent",
        color: "#FFFFFF",
        border: "none !important",
        fontFamily: '"Poppins", sans-serif',
    },
    "&.MuiToggleButton-root:first-of-type": {
        borderRadius: "8px 0 0 8px",
    },
    "&.MuiToggleButton-root:last-of-type": {
        borderRadius: "0 8px 8px 0",
    },
    "&.MuiToggleButton-root:only-of-type": {
        borderRadius: "8px",
    },
    "&.MuiToggleButton-root.Mui-selected": {
        backgroundColor: "#FFC540",
        color: "#3E3A3F",
        "&:hover": {
            backgroundColor: "#FFC540",
            color: "#3E3A3F",
        },
    },
    "&.MuiToggleButton-root:hover": {
        backgroundColor: "rgba(255, 197, 64, 0.1)",
    },
    "&.MuiToggleButton-root.Mui-disabled": {
        color: "rgba(255,255,255,0.3)",
    },
    "&.MuiToggleButton-root.Mui-disabled.Mui-selected": {
        backgroundColor: "rgba(255,197,64,0.3)",
        color: "rgba(62,58,63,0.5)",
    },
});

export const useStyles = makeStyles({
    mainContainer: {
        borderRadius: 8,
        border: '1px solid #4a5058',
        background: '#3A3E3F',
        maxWidth: '100%',
        height: '100%',
    },
    mainHeading: {
        fontSize: '20px',
        fontWeight: 700,
        lineHeight: '24px',
        color: '#FFFFFF'
    },
    closeIcon: {
        color: '#969696'
    },
    secondHeading: {
        fontWeight: 400,
        fontSize: '42px !important',
        lineHeight: '51px',
        color: '#FFFFFF',
    },
    years: {
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '17px',
        color: '#FFFFFF'
    },
    data: {
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '17px',
        color: '#FFFFFF'
    },
    per: {
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '17px',
        color: '#697588'
    },
    selectLabel: {
        /* ---- Outlined ---- */
        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {borderColor: '#FFFFFF'},
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {borderColor: '#FFC540'},
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: '#FFC540'},
        '& .MuiOutlinedInput-root fieldset': {borderRadius: 8},
        '& .MuiOutlinedInput-input': {color: '#FFFFFF'},
        '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-input': {WebkitTextFillColor: 'rgba(255,255,255,0.5) !important'},
        '& .MuiOutlinedInput-root.Mui-disabled textarea': {WebkitTextFillColor: 'rgba(255,255,255,0.5) !important'},
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input': {color: '#FFFFFF'},

        /* ---- Standard ---- */
        '& .MuiInput-root': {color: '#FFFFFF'},                       // text color
        '& .MuiInput-root:before': {borderBottomColor: '#FFFFFF'},    // default underline
        '& .MuiInput-root:hover:not(.Mui-disabled):before': {borderBottomColor: '#FFFFFF'},
        '& .MuiInput-root.Mui-focused:after': {borderBottomColor: '#FFFFFF'},

        /* ---- Common label / icon ---- */
        '& .MuiInputLabel-root': {color: '#FFFFFF'},
        '& .MuiInputLabel-root.Mui-focused': {color: '#FFFFFF'},
        '& svg': {color: '#FFFFFF'},
    },

    /* === GREY-ONLY DIFFS === */
    selectLabelGreyDiff: {
        /* ---- Outlined ---- */
        '& .MuiOutlinedInput-root': {
            '& fieldset': {borderColor: '#C7CCD0', borderRadius: '8px'},
            '&:hover fieldset': {borderColor: '#C7CCD0'},
            '&.Mui-focused fieldset': {borderColor: '#C7CCD0'},
        },
        '& .MuiInputBase-root.Mui-disabled > fieldset': {
            color: 'rgba(255,255,255,0.5)',
            borderColor: '#C7CCD0',
        },
        '& .MuiSelect-root': {
            borderRadius: 8,
            '& > fieldset': {color: 'rgba(255,255,255,0.5)'},
            '& .Mui-disabled, & .Mui-input': {color: 'rgba(255,255,255,0.5)'},
        },

        /* ---- Standard ---- */
        '& .MuiInput-root:before': {borderBottomColor: '#C7CCD0'},
        '& .MuiInput-root:hover:not(.Mui-disabled):before': {borderBottomColor: '#C7CCD0'},
        '& .MuiInput-root.Mui-focused:after': {borderBottomColor: '#C7CCD0'},
        '& .MuiInput-root.Mui-disabled:before': {borderBottomColor: '#C7CCD0'},

        '& .MuiInputBase-root.Mui-disabled': {color: 'rgba(255,255,255,0.5) !important'},
        '& .MuiOutlinedInput-input.Mui-disabled': {
            WebkitTextFillColor: 'rgba(255,255,255,0.5) !important',
            color: 'rgba(255,255,255,0.5) !important',
        },

        '& .MuiOutlinedInput-input': {color: '#FFFFFF'},
        '& svg': {color: '#FFFFFF'},

        '& .MuiInputLabel-root': {
            color: 'rgba(255,255,255,0.5)',
            '&.Mui-focused': {color: '#FFC540'},
            '&.Mui-disabled': {color: 'rgba(255,255,255,0.5) !important'},
        },
    },


    switchLabelWhite: {
        '& .MuiFormControlLabel-label': {color: '#FFFFFF !important'},
        '& .MuiFormControlLabel-label.Mui-disabled': {color: 'rgba(255,255,255,0.5) !important'},

        /* track (both states get full opacity so colors look solid) */
        '& .MuiSwitch-track': {backgroundColor: '#5F5F5F', opacity: 1},

        /* thumb + state styles */
        '& .MuiSwitch-switchBase': {
            color: '#FFFFFF',                      // OFF thumb
            '&.Mui-checked': {
                color: '#FFC540',                    // ON thumb
                '& + .MuiSwitch-track': {opacity: 1, backgroundColor: '#8A7530'},        // ON track (desaturated gold)
            },
            '&.Mui-disabled': {
                color: 'rgba(255,255,255,0.5)',
                '& + .MuiSwitch-track': {backgroundColor: 'rgba(255,255,255,0.3)', opacity: 1,},
            },
        },
    },

    /* === GREY-ONLY DIFFS === */
    switchLabelGreyDiff: {
        '& .MuiFormControlLabel-label': {
            color: 'rgba(255,255,255,0.5)',
            '&.Mui-disabled': {color: 'rgba(255,255,255,0.3)'},
        },

        '& .MuiSwitch-track': {backgroundColor: '#4e5152'},            // OFF track override

        '& .MuiSwitch-switchBase': {
            color: '#C7CCD0',                      // OFF thumb override
            '&.Mui-checked': {
                color: '#FFC540',                    // keep same ON thumb
                '& + .MuiSwitch-track': {backgroundColor: '#8A7530'},        // keep same ON track (or override if needed)
            },
        },
    },
    // Typography hierarchy
    headingLarge: {
        fontWeight: 500,
        fontSize: '26px',
        color: '#FFFFFF',
        lineHeight: '26px'
    },
    labelMuted: {
        fontWeight: 500,
        fontSize: '16px',
        color: '#BABABA',
        lineHeight: '19.36px'
    },
    valueWhite: {
        fontWeight: 500,
        fontSize: '19px',
        lineHeight: '28px',
        color: '#FFFFFF',
        lineBreak: "anywhere"
    },
    dividerSubtle: {
        height: '1px',
        color: '#6E6D6D',
        backgroundColor: '#6E6D6D',
        borderWidth: '0px'
    },
    // Small muted helper/hint text
    hintText: {
        fontSize: '12px',
        color: '#BABABA',
    },
    // Plain white Poppins text — use as sx spread: {...classes.textWhite}
    textWhite: {
        color: '#FFFFFF',
        fontFamily: 'Poppins',
    },
    // Form field label
    fieldLabel: {
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '17px',
        color: '#FFFFFF'
    },
    // Multi-select "Select All" item highlight
    selectedAll: {
        backgroundColor: "rgba(255, 197, 64, 0.1)",
        "&:hover": {backgroundColor: "rgba(255, 197, 64, 0.1)"},
    },
    // Multi-select indeterminate checkbox colour
    indeterminateColor: {
        color: "#FFC540",
    },
});

/**
 * ToggleButtonGroupField — matches the fieldset+legend+ToggleButtonPill pattern
 * used in OptionsEngine/OptionField renderToggleButtonGroupField.
 * Usage:
 *   <ToggleButtonGroupField
 *     label="Availability period"
 *     items={[{label: "1 Day", value: "1d"}, ...]}
 *     value={selected}
 *     onChange={setSelected}
 *   />
 */
export const ToggleButtonGroupField = ({label, items = [], value, onChange, disabled = false}) => (
    <fieldset style={{
        border: '1px solid #C7CCD0',
        borderRadius: '8px',
        padding: '2px 6px 6px 6px',
        margin: 0,
        minInlineSize: 'auto',
    }}>
        {label && (
            <legend style={{
                color: disabled ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.7)',
                fontSize: '12px',
                fontFamily: 'Poppins, sans-serif',
                padding: '0 4px',
            }}>
                {label}
            </legend>
        )}
        <MuiToggleButtonGroup
            exclusive
            value={value}
            onChange={(_, val) => { if (val !== null) onChange?.(val); }}
            disabled={disabled}
        >
            {items.map(({label: l, value: v, disabled: d = false}) => (
                <ToggleButtonPill key={v} value={v} disabled={d}>
                    {l}
                </ToggleButtonPill>
            ))}
        </MuiToggleButtonGroup>
    </fieldset>
);

/**
 * DateTimePickerField — combined date + time picker pair styled to match the platform.
 * Uses @mui/x-date-pickers DatePicker + TimePicker with AdapterDayjs.
 * Value is a local datetime string "YYYY-MM-DDTHH:mm" matching the operator's timezone.
 *
 * Props:
 *   value      — "YYYY-MM-DDTHH:mm" string (controlled)
 *   onChange   — (value: "YYYY-MM-DDTHH:mm" | "") => void
 *   minDate    — minimum selectable date as "YYYY-MM-DDTHH:mm" string (optional)
 *   disabled   — boolean (optional)
 */
export const DateTimePickerField = ({value, onChange, minDate, disabled = false, inputHeight = 40}) => {
    const dayjsValue = value ? dayjs(value) : null;
    const dayjsMin = minDate ? dayjs(minDate) : undefined;

    const handleDateChange = (newDate) => {
        if (!newDate || !newDate.isValid()) { onChange(""); return; }
        const time = dayjsValue ? dayjsValue.format("HH:mm") : "00:00";
        onChange(`${newDate.format("YYYY-MM-DD")}T${time}`);
    };

    const handleTimeChange = (newTime) => {
        if (!newTime || !newTime.isValid()) return;
        const date = dayjsValue ? dayjsValue.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
        onChange(`${date}T${newTime.format("HH:mm")}`);
    };

    const pickerSx = {
        width: 'fit-content',
        '& .MuiOutlinedInput-root': {
            height: inputHeight,
            backgroundColor: '#3A3E3F',
            '&:hover': {backgroundColor: '#3A3E3F'},
            '&.Mui-focused': {backgroundColor: '#3A3E3F'},
            '& fieldset': {borderColor: '#FFFFFF !important', borderRadius: '8px'},
            '&:hover fieldset': {borderColor: '#FFFFFF !important'},
            '&.Mui-focused fieldset': {borderColor: '#FFC540 !important'},
            '&.Mui-disabled fieldset': {borderColor: 'rgba(255,255,255,0.3) !important'},
        },
        '& .MuiInputLabel-root': {color: 'rgba(255,255,255,0.5)', '&.Mui-focused': {color: '#FFC540'}},
        '& .MuiInputBase-input': {color: '#FFFFFF', textAlign: 'center', backgroundColor: 'transparent', colorScheme: 'dark'},
        '& .MuiInputBase-input.Mui-disabled': {WebkitTextFillColor: 'rgba(255,255,255,0.3) !important'},
        '& svg': {color: '#FFFFFF'},
        '& .Mui-disabled svg': {color: 'rgba(255,255,255,0.3)'},
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack direction="row" gap={1} alignItems="center">
                <DatePicker
                    value={dayjsValue}
                    onChange={handleDateChange}
                    minDate={dayjsMin}
                    disabled={disabled}
                    format="DD/MMM/YYYY"
                    slotProps={{
                        textField: {size: "small", sx: pickerSx, inputProps: {size: 11}},
                        openPickerButton: {sx: {color: '#FFFFFF', padding: '2px'}},
                    }}
                />
                <TimePicker
                    value={dayjsValue}
                    onChange={handleTimeChange}
                    disabled={disabled}
                    ampm={false}
                    slotProps={{
                        textField: {size: "small", sx: pickerSx, inputProps: {size: 5}},
                        openPickerButton: {sx: {color: '#FFFFFF', padding: '2px'}},
                    }}
                />
            </Stack>
        </LocalizationProvider>
    );
};

/**
 * HintText — matches the hint style used in OptionsEngine/OptionField.
 * Usage: <HintText>* Some hint message</HintText>
 *        <HintText disabled>* Greyed out hint</HintText>
 */
export const HintText = ({children, disabled = false, sx = {}}) => (
    <Typography sx={{
        color: disabled ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.5)',
        fontSize: '11px',
        fontStyle: 'italic',
        fontFamily: 'Poppins, sans-serif',
        textAlign: 'left',
        mt: 0.5,
        ...sx,
    }}>
        {children}
    </Typography>
);

// Overrides App.css global "input, select { -webkit-text-fill-color: #fff !important }"
// for disabled inputs within a scoped container. Apply on a parent element via sx.
// Usage: <Box sx={disabledInputGreySx}>...</Box>
export const disabledInputGreySx = {
    '& input:disabled': {color: 'rgba(255,255,255,0.5) !important', WebkitTextFillColor: 'rgba(255,255,255,0.5) !important'},
    '& textarea:disabled': {color: 'rgba(255,255,255,0.5) !important', WebkitTextFillColor: 'rgba(255,255,255,0.5) !important'},
};

// Plain sx-compatible style object for TextField validation errors in platform gold.
// Cannot live inside makeStyles (which returns class name strings, incompatible with sx).
// Usage: sx={hasError ? goldErrorFieldSx : {}}
export const goldErrorFieldSx = {
    '& .MuiOutlinedInput-root': {
        '& fieldset': {borderColor: '#FFC540 !important'},
        '&:hover fieldset': {borderColor: '#FFC540 !important'},
        '&.Mui-focused fieldset': {borderColor: '#FFC540 !important'},
    },
    '& .MuiInputLabel-root': {
        color: '#FFC540 !important',
    },
};

/**
 * Tooltip bubble – arrow on TOP, centered on the anchor point Google Charts positions its HTML-tooltip container at.
 *
 * @param {string | ReactElement} content
 * @param {object} [opts]
 *        background   bubble colour                 (default rgba(0,0,0,0.65))
 *        textColor    text colour                   (default #fff)
 *        borderRadius px                            (default 4)
 *        arrowSize    px                            (default 6)
 *        padding      CSS padding                   (default "6px 8px")
 *        offsetY      extra px below arrow tip      (default 4)
 * @returns {string}   HTML string for generateTooltip
 */
export const googleChartTooltipBubble = (content, opts = {}) => {
    const {
        background = 'rgba(0,0,0,0.65)',
        textColor = '#fff',
        borderRadius = 4,
        arrowSize = 6,
        padding = '6px 8px',
        gap = 2,
        offsetY = 15
    } = opts;

    const innerHTML =
        typeof content === 'string' ? content : renderToStaticMarkup(content);

    return `
    <div style="
    position:relative; 
    pointer-events:none;
    top:${offsetY}px;
    z-index:2600;"
    class="google-chart-custom-tooltip-bubble">

      <!-- ▲  arrow – apex at (0,0) -->
      <div style="
        position:absolute;
        top:0;
        left:50%;
        transform:translateX(-50%);
        width:0; height:0;
        border-left:${arrowSize}px solid transparent;
        border-right:${arrowSize}px solid transparent;
        border-bottom:${arrowSize}px solid ${background};
      "></div>

      <!-- ■  bubble – centered under arrow -->
      <div style="
        position:absolute;
        top:${arrowSize + gap}px;
        left:50%;
        transform:translateX(-50%);
        background:${background};
        color:${textColor};
        padding:${padding};
        border-radius:${borderRadius}px;
        font-size:12px;
        line-height:1.3;
        white-space:nowrap;
      ">
        ${innerHTML}
      </div>
    </div>`;
};

/**
 * AppSnackbar — platform-wide severity-coloured snackbar.
 * Extends the existing plain Snackbar pattern with colour coding.
 *
 * Severity colours:
 *   error   → #FF6C65 background, white text
 *   warning → #FFC540 background, dark text (#3A3E3F)
 *   info    → MUI default
 *   success → MUI default
 *
 * Usage:
 *   const [snackbar, setSnackbar] = useState({open: false, message: "", severity: "info"});
 *   const openSnackbar = (message, severity = "info") => setSnackbar({open: true, message, severity});
 *   const closeSnackbar = () => setSnackbar(s => ({...s, open: false}));
 *   <AppSnackbar open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={closeSnackbar}/>
 */
export const AppSnackbar = ({open, message, severity = "info", onClose, autoHideDuration = 10000}) => {
    const normalizedMessage = typeof message === 'string' ? message.trim() : message;
    if (!open || !normalizedMessage) {
        return null;
    }

    const contentProps = {
        sx: severity === "error"
            ? {backgroundColor: '#FF6C65', color: '#FFFFFF'}
            : severity === "warning"
                ? {backgroundColor: '#FFC540', color: '#3A3E3F'}
                : {},
    };

    return (
        <Snackbar
            anchorOrigin={{vertical: "top", horizontal: "right"}}
            open={open}
            onClose={onClose}
            message={normalizedMessage}
            autoHideDuration={autoHideDuration}
            ContentProps={contentProps}
        />
    );
};
export const colourPalette = [
    '#007E23',
    '#F4BF37',
    '#38AA58',
    '#EE3F3F',
    '#C15959',
];

/**
 * Compute midColor (≈37 % white) and minColor (≈73 % white)
 * for a given maxColor.
 *
 * @param {string} maxHex - A 6-digit CSS hex string like "#007E23".
 * @returns {Object} An object with maxColor, midColor, and minColor properties.
 */
export function colorShades(maxHex) {
    const MAX_TO_WHITE_RATIOS = {mid: 0.37, min: 0.73};

    // --- helpers -------------------------------------------------
    const hex2rgb = hex =>
        hex.replace(/^#/, '')
            .match(/.{2}/g)
            .map(h => parseInt(h, 16));

    const rgb2hex = rgb =>
        '#' + rgb.map(v => v.toString(16).padStart(2, '0')).join('');

    const blendWithWhite = (rgb, ratio) =>
        rgb.map(v => Math.round(v * (1 - ratio) + 255 * ratio));
    // -------------------------------------------------------------

    const maxRgb = hex2rgb(maxHex);
    const midRgb = blendWithWhite(maxRgb, MAX_TO_WHITE_RATIOS.mid);
    const minRgb = blendWithWhite(maxRgb, MAX_TO_WHITE_RATIOS.min);

    return {
        maxColor: maxHex.toUpperCase(),
        midColor: rgb2hex(midRgb).toUpperCase(),
        minColor: rgb2hex(minRgb).toUpperCase(),
    };
}

export const Accordion = styled((props) => (
    <MuiAccordion
        disableGutters
        elevation={1}
        square
        {...props}
    />))(({theme}) => (
    {
        backgroundColor: '#4e5152',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#4e5152', // theme.palette.divider,
        '&:not(:last-child)': {borderBottom: 0,},
        '&::before': {display: 'none',},
    }));

export const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{fontSize: '0.9rem'}}/>}
        {...props}
    />
))(({theme}) => ({
    backgroundColor: '#4e5152',
    color: '#FFFFFF',
    flexDirection: 'row-reverse',

    /* default icon colour */
    [`& .${accordionSummaryClasses.expandIconWrapper} svg`]: {
        color: '#ffc540',
    },

    /* expanded state */
    '&.Mui-expanded': {
        backgroundColor: '#ffc540',
        color: '#3a3e3f',

        /* rotate + recolor icon when open */
        [`& .${accordionSummaryClasses.expandIconWrapper} svg`]: {
            transform: 'rotate(270deg)',
            color: '#4e5152',
        },
    },

    /* content spacing */
    [`& .${accordionSummaryClasses.content}`]: {
        marginLeft: theme.spacing(1),
    },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({theme}) => ({
    padding: theme.spacing(2),
    backgroundColor: '#3a3e3f',
    borderRightWidth: '3px',
    borderRightStyle: 'solid',
    borderRightColor: '#4e5152'
}));

// Shared disabled style for the app's primary styled buttons.
// Default MUI disabled is rgba(0,0,0,0.87)-ish on a charcoal page → unreadable.
// Use the lighter charcoal that DataTable headers use, with low-contrast white text and no border.
// Fully neutral (overrides the destruction-red variant) — disabled means "cannot act"; red would mislead.
const _disabledButtonSx = {
    "&.Mui-disabled": {
        background: "#606263",
        backgroundColor: "#606263",
        color: "rgba(255,255,255,0.4)",
        borderColor: "transparent",
    },
};

export const StyledButtonContained = styled(Button)({
    textTransform: "none",
    fontWeight: 700,
    background: "linear-gradient(180deg, #EEAB10 0%, #FFC133 100%)",
    color: "#3A3E3F",
    borderRadius: "30px",
    "&:hover": {
        backgroundColor: "linear-gradient(180deg, #EEAB10 0%, #FFC133 100%)",
        color: "#3A3E3F",
    },
    ..._disabledButtonSx,
});

export const StyledButtonOutlined = styled(Button)({
    textTransform: "none",
    fontWeight: 700,
    background: "transparent",
    color: "#FFC540",
    borderRadius: "30px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#FFC133",
    "&:hover": {
        backgroundColor: "transparent",
        color: "#FFC540",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "#FFC133",
    },
    ..._disabledButtonSx,
});

export const StyledButtonText = styled(Button)({});

export const ConfirmDialog = ({open, onClose, onConfirm, title = "Are you sure?", message}) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth={true}
                PaperProps={{sx: {borderRadius: "12px", backgroundColor: '#3A3E3F'}}}>
            <DialogContent>
                <Grid container direction='column' spacing={2}>
                    <Grid item>
                        <Typography style={{fontWeight: 600, fontSize: '24px', lineHeight: '36px', color: '#FFC540'}}>
                            {title}
                        </Typography>
                    </Grid>
                    <Grid item p={4}>
                        <Typography style={{width: 'inherit', color: '#FFFFFF', fontFamily: 'Poppins'}}>
                            {message}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Grid container direction='row' justifyContent='space-between'>
                            <Grid item>
                                <StyledButtonOutlined variant='outlined' onClick={onClose}
                                                      sx={{width: '200px', height: '60px'}}>
                                    Cancel
                                </StyledButtonOutlined>
                            </Grid>
                            <StyledButtonContained variant='contained' onClick={onConfirm}
                                                   sx={{width: '200px', height: '60px'}}>
                                Confirm
                            </StyledButtonContained>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

// ------------------------------------------------
// Stepper Components
// ------------------------------------------------

export const WizardStepIconRoot = styled("div")(({ownerState}) => ({
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    background: "#3A3E3F",
    textAlign: "center",
    zIndex: 2,
    opacity: ownerState.completed ? 1 : 0.5,

    ...(ownerState.active && {
        background: "#FFC540",
        border: "2px inset #3A3E3F",
        opacity: 1,
    }),

    ...(ownerState.completed && {
        opacity: 1,
    }),

    "& .MuiStepIcon-completed": {
        color: "#FFC540",
    },

    "& .MuiStepIcon-circle": {
        color: "#3A3E3F",
    },
}));

export function WizardStepIcon(props) {
    const {active, completed, className} = props;
    return (
        <WizardStepIconRoot
            ownerState={{completed, active}}
            className={className}
        >
            {completed ? (
                <CheckOutlined
                    className="MuiStepIcon-completed"
                    style={{opacity: 1}}
                />
            ) : (
                <div
                    className="MuiStepIcon-circle"
                    style={{opacity: active ? 1 : 0.5}}
                />
            )}
        </WizardStepIconRoot>
    );
}

WizardStepIcon.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool,
    className: PropTypes.string,
};

export const WizardStepConnector = styled(StepConnector)(() => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        left: "calc(-50% + 12px)",
        right: "calc(50% + 12px)",
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: "#3A3E3F",
            opacity: 1,
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: "#3A3E3F",
            opacity: 1,
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#3A3E3F",
        opacity: 0.5,
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));

export const SearchBar = ({value, onChange, onClear}) => (
    <InputBase
        type="text"
        placeholder="Search"
        value={value}
        onChange={onChange}
        startAdornment={
            <InputAdornment position="start" sx={{color: '#A6AEC1', height: 24, width: 24}}>
                <Search/>
            </InputAdornment>
        }
        endAdornment={
            value !== '' && (
                <InputAdornment position="end" sx={{color: '#A6AEC1', height: 24, width: 24}}>
                    <IconButton onClick={onClear}><Cancel sx={{color: '#FFFFFF'}}/></IconButton>
                </InputAdornment>
            )
        }
        sx={{
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '15px',
            letterSpacing: '0em',
            textAlign: 'left',
            width: '100%',
            height: '60px',
            backgroundColor: PrimaryColor,
            borderRadius: '12px',
            px: '20px',
            border: '1px solid #C7CCD0',
            outline: 'none',
            color: '#FFFFFF',
        }}
    />
);

export const SelectAccountDialog = ({open, onClose, customers, onConfirm}) => {
    const [selectedUuid, setSelectedUuid] = useState('');

    const handleClose = () => {
        setSelectedUuid('');
        onClose();
    };

    const handleConfirm = () => {
        if (selectedUuid) {
            onConfirm(selectedUuid);
            setSelectedUuid('');
        }
    };

    return (
        <Dialog open={open} fullWidth={true} PaperProps={{sx: {borderRadius: "12px", backgroundColor: '#3A3E3F'}}}>
            <DialogContent>
                <Grid container direction='column' spacing={2}>
                    <Grid item>
                        <Grid container justifyContent='space-between' alignItems='center'>
                            <Typography sx={{color: '#FFC540', fontWeight: 600, fontSize: '24px'}}>Select Account</Typography>
                            <Close onClick={handleClose} sx={{color: 'white', cursor: 'pointer'}}/>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <TextField
                            fullWidth
                            select
                            value={selectedUuid}
                            onChange={(e) => setSelectedUuid(e.target.value)}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    color: '#ffffff !important',
                                    "& fieldset": {border: "1px solid #C7CCD0 !important", borderRadius: '8px !important'},
                                },
                            }}>
                            {customers.map((c) => (
                                <MenuItem key={c.uuid} value={c.uuid}>{c.company_name}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item>
                        <Grid container justifyContent='flex-end' spacing={2}>
                            <Grid item>
                                <StyledButtonOutlined variant='outlined' onClick={handleClose}>
                                    Cancel
                                </StyledButtonOutlined>
                            </Grid>
                            <Grid item>
                                <StyledButtonContained variant='contained' onClick={handleConfirm} disabled={!selectedUuid}>
                                    Continue
                                </StyledButtonContained>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export const SelectAddressDialog = ({open, onClose, addresses, onConfirm}) => {
    const [selectedIndex, setSelectedIndex] = useState('');

    const handleClose = () => {
        setSelectedIndex('');
        onClose();
    };

    const handleConfirm = () => {
        if (selectedIndex !== '') {
            onConfirm(addresses[selectedIndex]);
            setSelectedIndex('');
        }
    };

    return (
        <Dialog open={open} fullWidth maxWidth="sm" PaperProps={{sx: {borderRadius: "12px", backgroundColor: '#3A3E3F'}}}>
            <DialogContent>
                <Grid container direction='column' spacing={2}>
                    <Grid item>
                        <Grid container justifyContent='space-between' alignItems='center'>
                            <Typography sx={{color: '#FFC540', fontWeight: 600, fontSize: '24px'}}>Select Address</Typography>
                            <Close onClick={handleClose} sx={{color: 'white', cursor: 'pointer'}}/>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <TextField
                            fullWidth
                            select
                            value={selectedIndex}
                            label="Choose an address"
                            onChange={(e) => setSelectedIndex(e.target.value)}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    color: '#ffffff !important',
                                    "& fieldset": {border: "1px solid #C7CCD0 !important", borderRadius: '8px !important'},
                                },
                                "& .MuiInputLabel-root": {color: '#BABABA'},
                            }}
                            SelectProps={{
                                renderValue: (idx) => {
                                    const addr = addresses[idx];
                                    if (!addr) return '';
                                    const parts = [addr.address_line_1, addr.city, addr.state, addr.country].filter(Boolean);
                                    return parts.join(', ');
                                }
                            }}
                        >
                            {addresses.map((addr, i) => (
                                <MenuItem key={i} value={i} sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', py: 1}}>
                                    {addr._label && (
                                        <Typography sx={{fontSize: 11, color: '#BABABA', fontFamily: 'Poppins', mb: 0.5}}>{addr._label}</Typography>
                                    )}
                                    <Typography sx={{fontSize: 13, color: '#FFFFFF', fontFamily: 'Poppins'}}>
                                        {[addr.address_line_1, addr.address_line_2].filter(Boolean).join(', ')}
                                    </Typography>
                                    <Typography sx={{fontSize: 12, color: '#BABABA', fontFamily: 'Poppins'}}>
                                        {[addr.city, addr.state, addr.postal_code, addr.country].filter(Boolean).join(', ')}
                                    </Typography>
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item>
                        <Grid container justifyContent='flex-end' spacing={2}>
                            <Grid item>
                                <StyledButtonOutlined variant='outlined' onClick={handleClose}>Cancel</StyledButtonOutlined>
                            </Grid>
                            <Grid item>
                                <StyledButtonContained variant='contained' onClick={handleConfirm} disabled={selectedIndex === ''}>
                                    Select
                                </StyledButtonContained>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

const multiSelectMenuProps = {
    anchorOrigin: {vertical: "bottom", horizontal: "center"},
    transformOrigin: {vertical: "top", horizontal: "center"},
    variant: "menu"
};

// Returns "All" when all/none selected, the single label when exactly one selected, "Multiple" otherwise
export const renderMultiSelectValue = (selected, totalCount, labelFn) => {
    if (selected.length === 0 || selected.length === totalCount) return "All";
    if (selected.length === 1) return labelFn ? labelFn(selected[0]) : selected[0];
    return "Multiple";
};

/**
 * A labelled multi-select dropdown with "Select All" checkbox.
 * @param {string} label - Label text shown to the left of the dropdown
 * @param {Array<{key, value}>} options - Available options
 * @param {string[]} selected - Array of selected keys
 * @param {function} onChange - Called with new selected array
 * @param {number} [minWidth=120] - Minimum width of the dropdown
 */
export const LabelledMultiSelect = ({label, options, selected, onChange, minWidth = 120}) => {
    const classes = useStyles();
    const labelMap = Object.fromEntries(options.map(o => [o.key, o.value]));
    const isAllSelected = selected.length === options.length;

    const handleChange = (event) => {
        const value = event.target.value;
        if (value[value.length - 1] === "all") {
            onChange(isAllSelected ? [] : options.map(o => o.key));
            return;
        }
        onChange(value);
    };

    return (
        <Grid container alignItems="center" spacing={1}>
            <Grid item>
                <Typography sx={{fontFamily: 'Poppins', color: '#FFFFFF', fontSize: '16px'}}>{label}:</Typography>
            </Grid>
            <Grid item>
                <Select
                    multiple
                    value={selected}
                    onChange={handleChange}
                    renderValue={(sel) => renderMultiSelectValue(sel, options.length, k => labelMap[k])}
                    displayEmpty
                    MenuProps={multiSelectMenuProps}
                    variant="outlined"
                    sx={{color: 'white', border: '1px solid #C7CCD0', borderRadius: '8px', minWidth}}
                >
                    <MenuItem value="all" classes={{root: isAllSelected ? classes.selectedAll : ""}}>
                        <ListItemIcon>
                            <Checkbox
                                sx={{color: '#FFFFFF'}}
                                classes={{indeterminate: classes.indeterminateColor}}
                                checked={isAllSelected}
                                indeterminate={selected.length > 0 && !isAllSelected}
                            />
                        </ListItemIcon>
                        <ListItemText primary="Select All"/>
                    </MenuItem>
                    {options.map((option) => (
                        <MenuItem key={option.key} value={option.key}>
                            <ListItemIcon>
                                <Checkbox sx={{color: '#FFFFFF'}} checked={selected.indexOf(option.key) > -1}/>
                            </ListItemIcon>
                            <ListItemText primary={option.value}/>
                        </MenuItem>
                    ))}
                </Select>
            </Grid>
        </Grid>
    );
};

/**
 * A labelled single-select dropdown.
 * @param {string} label - Label text shown to the left of the dropdown
 * @param {Array<{label, value}>} options - Available options
 * @param {string} value - Currently selected value
 * @param {function} onChange - Called with new value
 * @param {object} [inputProps] - Extra props forwarded to the inner TextField (e.g. data-testid)
 */
export const LabelledSingleSelect = ({label, options, value, onChange, inputProps = {}}) => (
    <Grid container alignItems="center" spacing={1}>
        <Grid item>
            <Typography sx={{fontFamily: 'Poppins', color: '#FFFFFF', textAlign: 'left', fontSize: '16px'}}>{label}:</Typography>
        </Grid>

        <Grid item>
            <TextField
                variant="outlined"
                select
                value={value}
                onChange={(e) => onChange(e.target.value)}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        color: '#ffffff !important',
                        "& fieldset": {border: "1px solid #C7CCD0 !important", borderRadius: '8px !important'},
                    },
                }}
                {...inputProps}
            >
                {options.map((r) => (
                    <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>
                ))}
            </TextField>
        </Grid>
    </Grid>
);

const ProgressSlider = styled(Slider)({
    color: "#D9D9D9",
    height: 12,
    "& .MuiSlider-track": {
        height: 12,
        border: "none",
        color: "#FFC540",
    },
    "& .MuiSlider-thumb": {
        height: 20,
        width: "auto",
        minWidth: 36,
        borderRadius: "6px",
        backgroundColor: "#FFC540",
        border: "none",
        "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {boxShadow: "inherit"},
        "&:before": {display: "none"},
    },
    "& .MuiSlider-valueLabel": {
        fontFamily: "Poppins",
        fontWeight: 500,
        lineHeight: 1,
        fontSize: 11,
        background: "unset",
        padding: 0,
        color: "#3A3E3F",
        backgroundColor: "transparent",
        top: "50%",
        transform: "translateY(-50%)",
        "&:before": {display: "none"},
        "&.MuiSlider-valueLabelOpen": {transform: "translateY(-50%)"},
    },
});

/**
 * Reusable progress bar with gold slider, percentage circle, and optional detail box.
 * @param {string} label - Label shown to the left (e.g. "Audit", "Ingestion")
 * @param {number} value - Progress percentage (0-100)
 * @param {number} completedCount - Number of completed items
 * @param {number} totalCount - Total number of items
 * @param {boolean} [showDetails=false] - When true, renders the expanded detail box below the slider (legacy style)
 */
export const ProgressBar = ({label, value, completedCount, totalCount, showDetails = false}) => (
    <Box sx={{mb: showDetails ? 10 : 1.5}}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
            <Typography sx={{fontFamily: "Poppins", fontWeight: 600, fontSize: "13px", color: "#FFFFFF", minWidth: "110px", textAlign: "left"}}>
                {label}
            </Typography>
            <Box sx={{flex: 1, position: "relative"}}>
                <ProgressSlider
                    disabled
                    value={value}
                    valueLabelDisplay="on"
                    valueLabelFormat={(v) => `${Math.round(v)}%`}
                />
                {showDetails && (
                    <Box sx={{
                        width: "91px",
                        height: "95px",
                        borderRadius: "8px",
                        border: "1px solid #FFC540",
                        position: "absolute",
                        top: "calc(100% + 8px)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: PrimaryColor,
                        zIndex: 1,
                        marginLeft: `calc(${value}% - 40px)`
                    }}>
                        <Stack direction="column" alignItems="center">
                            <Typography sx={{fontFamily: "Poppins", fontWeight: 700, fontSize: "22px", lineHeight: "33px", color: "#FFC540"}}>
                                {completedCount}/{totalCount}
                            </Typography>
                            <Typography sx={{fontFamily: "Poppins", fontWeight: 400, fontSize: "14px", lineHeight: "20px", color: "#FFFFFF"}}>
                                {label}
                            </Typography>
                        </Stack>
                    </Box>
                )}
            </Box>
            {!showDetails && (
                <Typography sx={{fontFamily: "Poppins", fontWeight: 700, fontSize: "14px", color: "#FFC540", minWidth: "60px", textAlign: "right"}}>
                    {completedCount}/{totalCount}
                </Typography>
            )}
        </Box>
    </Box>
);

/**
 * Highlights occurrences of a search query within text. Returns the original text if no query.
 * @param {string} text - The text to search within
 * @param {string} query - The search query to highlight
 * @returns {string|Array} - Original text or array of React elements with highlights
 */
export const highlightText = (text, query) => {
    if (!query || !text) return text;
    const parts = String(text).split(new RegExp(`(${query})`, "gi"));
    return parts.map((part, i) =>
        part.toLowerCase() === query.toLowerCase()
            ? <mark key={i} style={{backgroundColor: "#FFC540", color: "#3A3E3F", padding: 0}}>{part}</mark>
            : part
    );
};


/**
 * Resolves an email to a Nexus user and displays a compact badge.
 *
 * Resolved:   [Avatar] First Last [×?]  — tooltip shows email, phone, role
 * Unresolved: email as plain text        — calls onUnresolved() if provided
 * Loading:    muted "Resolving..." text
 *
 * @param {string} email - Email to resolve
 * @param {"sm"|"md"} [size="md"] - Avatar size: sm=28px, md=40px
 * @param {function} [onClear] - If provided, renders a × button when resolved
 * @param {function} [onUnresolved] - Called when email cannot be matched to a Nexus user
 */
export const UserBadge = ({email, size = "md", onClear, onUnresolved}) => {
    const [user, setUser] = useState(undefined); // undefined=loading, null=not found, object=found
    const onUnresolvedRef = useRef(onUnresolved);
    onUnresolvedRef.current = onUnresolved;

    const avatarSize = size === "sm" ? 28 : 40;
    const fontSize = size === "sm" ? 12 : 14;

    useEffect(() => {
        if (!email) { setUser(null); return; }

        // Lazy import to avoid circular dependency — apiCalls imports from utils, not uiUtils
        import('./apiCalls').then(({resolveUserByEmail}) => {
            resolveUserByEmail(email)
                .then(match => {
                    setUser(match || null);
                    if (!match && onUnresolvedRef.current) onUnresolvedRef.current();
                })
                .catch(() => {
                    setUser(null);
                    if (onUnresolvedRef.current) onUnresolvedRef.current();
                });
        });
    }, [email]);

    // Loading state
    if (user === undefined) {
        return (
            <Typography sx={{fontSize, color: '#BABABA', fontFamily: 'Poppins'}}>
                Resolving...
            </Typography>
        );
    }

    // Unresolved — show email as-is (same as current orderSummary fallback)
    if (!user) {
        return (
            <Typography sx={{fontSize, color: '#FFFFFF', fontFamily: 'Poppins'}}>
                {email || '—'}
            </Typography>
        );
    }

    // Resolved — compact badge with tooltip
    const firstName = user.first_name || user.user?.first_name || '';
    const lastName = user.last_name || user.user?.last_name || '';
    const displayName = `${firstName} ${lastName}`.trim() || email;
    const pictureUrl = user.profile_picture_url || user.profile_picture || '';
    const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || '?';

    const tooltipContent = (
        <Box sx={{p: 0.5}}>
            <Typography sx={{fontSize: 13, fontWeight: 600}}>{displayName}</Typography>
            {email && <Typography sx={{fontSize: 12, color: '#BABABA'}}>{email}</Typography>}
            {(user.phone_number || user.user?.phone_number) &&
                <Typography sx={{fontSize: 12, color: '#BABABA'}}>{user.phone_number || user.user?.phone_number}</Typography>}
            {(user.mobile_number || user.user?.mobile_number) &&
                <Typography sx={{fontSize: 12, color: '#BABABA'}}>{user.mobile_number || user.user?.mobile_number}</Typography>}
            {(user.role || user.user?.role) &&
                <Typography sx={{fontSize: 12, color: '#FFC540'}}>{user.role || user.user?.role}</Typography>}
        </Box>
    );

    return (
        <Tooltip title={tooltipContent} arrow placement="top">
            <Box sx={{display: 'inline-flex', alignItems: 'center', gap: 1, cursor: 'default'}}>
                <Avatar
                    src={pictureUrl}
                    sx={{width: avatarSize, height: avatarSize, fontSize: avatarSize * 0.4}}
                >
                    {!pictureUrl && initials}
                </Avatar>
                <Typography sx={{fontSize, color: '#FFFFFF', fontFamily: 'Poppins'}}>
                    {displayName}
                </Typography>
                {onClear && (
                    <IconButton
                        size="small"
                        onClick={onClear}
                        sx={{color: '#BABABA', p: 0.25, '&:hover': {color: '#FFFFFF'}}}
                    >
                        <ClearIcon sx={{fontSize: fontSize + 2}}/>
                    </IconButton>
                )}
            </Box>
        </Tooltip>
    );
};

/**
 * Pure helper — computes the truncated display string for a grouped selection.
 * @param {object} value           — {[groupKey]: itemKey[]}
 * @param {array}  groups          — [{key, label, items:[{key,label}]}]
 * @param {string} selectedDisplay — 'item-only' | 'group-summary'
 * @param {number} maxDisplayLength
 * @param {string} noSelectionText
 * @param {number} [maxDisplayedItems] — At most this many labels are spelled out; the rest are counted as
 *        ' +N'. Omitted, the field fits as many labels as `maxDisplayLength` allows, which is right for a
 *        control sitting on its own but not for one with buttons beside it: the width then moves with the
 *        labels that happen to be selected, and the second selection either fits and shoves the buttons
 *        across or does not and reads as '+1'. Pass 1 and the field is one label plus a count at every
 *        size. See the header's job selector.
 * @returns {string}
 */
export const computeGroupedDisplayValue = (value, groups, selectedDisplay, maxDisplayLength, noSelectionText, maxDisplayedItems) => {
    const selectedItems = Object.values(value).flat();
    if (!selectedItems.length) return noSelectionText || '';

    let items;
    if (selectedDisplay === 'group-summary') {
        items = groups
            .filter(g => value[g.key]?.length)
            .map(g => ({label: g.label, count: value[g.key].length, text: `${g.label} (${value[g.key].length})`}));
    } else {
        const allItems = groups.flatMap(g => g.items);
        const selected = allItems.filter(i => selectedItems.includes(i.key));
        items = selected.map(i => ({label: i.label, text: i.label}));
    }
    if (!items.length) return noSelectionText || '';

    const totalSelected = selectedItems.length;
    const shownCount = (idx) => items.slice(0, idx + 1).reduce((sum, it) => sum + (it.count || 1), 0);
    const hiddenCount = (idx) => totalSelected - shownCount(idx);

    const truncFirst = (avail) => {
        if (selectedDisplay === 'group-summary') {
            const countSuffix = ` (${items[0].count})`;
            const room = avail - countSuffix.length - 3;
            return items[0].label.slice(0, Math.max(1, room)) + '...' + countSuffix;
        }
        return items[0].text.slice(0, Math.max(1, avail - 3)) + '...';
    };

    if (items.length === 1) {
        return items[0].text.length > maxDisplayLength ? truncFirst(maxDisplayLength) : items[0].text;
    }

    const hiddenIfOnlyFirst = hiddenCount(0);
    const availableForFirst = maxDisplayLength - ` +${hiddenIfOnlyFirst}`.length;

    let result;
    let hiddenItems = 0;
    if (items[0].text.length > availableForFirst) {
        result = truncFirst(availableForFirst);
        hiddenItems = hiddenIfOnlyFirst;
    } else {
        result = items[0].text;
        // A limit of one leaves the loop before its first pass, so the field is always 'label +N'.
        const displayLimit = maxDisplayedItems > 0 ? maxDisplayedItems : items.length;
        for (let i = 1; i < items.length; i++) {
            if (i >= displayLimit) {
                hiddenItems = hiddenCount(displayLimit - 1);
                break;
            }
            const candidate = result + ', ' + items[i].text;
            const hiddenAfterThis = hiddenCount(i);
            const remainingSuffix = hiddenAfterThis > 0 ? ` +${hiddenAfterThis}` : '';
            if (candidate.length + remainingSuffix.length > maxDisplayLength) {
                hiddenItems = hiddenCount(i - 1);
                break;
            }
            result = candidate;
        }
    }
    if (hiddenItems) result += ` +${hiddenItems}`;
    return result;
};

/**
 * CollapsibleGroupedSelect — Grouped dropdown with collapsible category headers.
 * Built on a display TextField + MUI Menu (Menu does not auto-close on item click,
 * so header-expand and multi-select stay open naturally; single-select closes explicitly).
 *
 * Props:
 *   groups          — [{key, label, items: [{key, label}]}]
 *   value           — {[groupKey]: itemKey[]}  (current selection; {} = nothing selected)
 *   onChange        — (newValue) => void
 *   disabled        — boolean (greyed out, default false)
 *   isMulti         — boolean (multi-select with checkboxes, default false; the group headers get a
 *                     checkbox of their own that takes or drops all of that group's items at once, and
 *                     shows indeterminate while only some of them are picked)
 *   singleGroup     — boolean (only meaningful with isMulti: constrain selection to ONE group;
 *                     adding an item from a different group atomically replaces the selection.
 *                     Default false = free multi-pick across groups.)
 *   renderItem      — (item, groupKey, isSelected) => ReactNode (optional custom item render)
 *   onGroupExpanded — (groupKey) => void (optional; fired for each group whose items are on screen,
 *                     so a caller drawing per-item detail can fetch it for the group the user opened
 *                     instead of for every group there is. See the note at the effect below.)
 *   title           — string (permanent field title, top-left corner)
 *   noSelectionText — string (displayed value when nothing selected, default "All")
 *   selectedDisplay — "item-only" | "group-summary"
 *   maxDisplayLength— number (truncation threshold, default 30)
 *   maxDisplayedItems — number (optional; how many labels the closed field spells out before it counts the
 *                     rest as ' +N'. Default: as many as fit. See computeGroupedDisplayValue.)
 *   minWidth        — number (default 160)
 */
export const CollapsibleGroupedSelect = ({
    groups = [],
    value = {},
    onChange,
    disabled = false,
    isMulti = false,
    singleGroup = false,
    renderItem,
    onGroupExpanded,
    noSelectionText = 'All',
    selectedDisplay = 'item-only',
    maxDisplayLength = 30,
    maxDisplayedItems,
    title = '',
    minWidth = 160,
    size = 'md',
}) => {
    const anchorRef = useRef(null);
    const isSmall = size === 'sm';
    const [open, setOpen] = useState(false);
    const [expanded, setExpanded] = useState(() => groups.length ? new Set([groups[0].key]) : new Set());

    // Re-seed expansion when the set of groups changes (async fetch arrival, customer switch).
    const groupKeysSig = groups.map(g => g.key).join(',');
    useEffect(() => {
        setExpanded(groups.length ? new Set([groups[0].key]) : new Set());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groupKeysSig]);

    const selectedItems = Object.values(value).flat();

    // One definition of "expanded", shared by the render below and the notification effect, so the
    // caller is told about exactly the groups whose items are on screen. A lone group is always
    // expanded (there is no other group to collapse it in favour of).
    const isGroupExpanded = (groupKey) => expanded.has(groupKey) || groups.length === 1;

    /*
     * Tells the caller which groups are showing their items, so anything expensive drawn per item can
     * be fetched for those groups only.
     *
     * Gated on `open` because a closed selector shows nothing: an admin's selector holds a group per
     * customer, and firing this at mount would fetch for all of them on every page load whether or not
     * the selector is ever touched. Re-fires when the expansion set changes, i.e. when a group is
     * opened, and again on each re-open of the menu — deliberately, since the caller is the only one
     * that knows whether its data is still fresh, and it is the caller that holds the cache.
     */
    const expandedSig = groups.filter(g => isGroupExpanded(g.key)).map(g => g.key).join(',');
    useEffect(() => {
        if (!open || typeof onGroupExpanded !== 'function') return;
        groups.forEach((group) => { if (isGroupExpanded(group.key)) onGroupExpanded(group.key); });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, expandedSig]);

    const displayText = useMemo(
        () => computeGroupedDisplayValue(value, groups, selectedDisplay, maxDisplayLength, noSelectionText, maxDisplayedItems),
        [value, groups, selectedDisplay, maxDisplayLength, noSelectionText, maxDisplayedItems]
    );

    const toggleGroup = (groupKey) => {
        setExpanded(prev => {
            const next = new Set(prev);
            if (next.has(groupKey)) next.delete(groupKey);
            else next.add(groupKey);
            return next;
        });
    };

    const handleItemClick = (groupKey, itemKey) => {
        const currentGroup = value[groupKey] || [];
        const isSelected = currentGroup.includes(itemKey);
        if (!isMulti) {
            onChange(isSelected ? {} : {[groupKey]: [itemKey]});
            setOpen(false);
            return;
        }
        // singleGroup constraint (multi-pick within ONE group): adding an item from a different
        // group than the currently-selected one atomically replaces the selection (silent switch).
        // NOTE: Object.keys() returns strings even for numeric keys, so coerce both sides for compare.
        if (singleGroup && !isSelected) {
            const groupKeyStr = String(groupKey);
            const otherGroupHasSelection = Object.keys(value).some(k => k !== groupKeyStr && value[k]?.length);
            if (otherGroupHasSelection) {
                onChange({[groupKey]: [itemKey]});
                return;
            }
        }
        const updatedGroup = isSelected
            ? currentGroup.filter(k => k !== itemKey)
            : [...currentGroup, itemKey];
        const newValue = {...value};
        if (updatedGroup.length) newValue[groupKey] = updatedGroup;
        else delete newValue[groupKey];
        onChange(newValue);
    };

    /**
     * Every item of one group at once, from the checkbox on its header.
     *
     * Asked for as 'if the company is selected all the jobs below it will be selected'. Only meaningful in
     * multi mode — a single-pick selector holds one item, so a control that picks a dozen would contradict
     * the rest of the menu, and the header there stays a collapse toggle and nothing else.
     *
     * A group that is already whole is cleared rather than re-selected, so the checkbox is a toggle in both
     * directions and the reader can undo the click that made it. Partially selected counts as not-selected:
     * clicking a box the user sees as half-filled fills it, which is the one reading of it that is never
     * surprising.
     *
     * `singleGroup` is honoured for the same reason handleItemClick honours it: where a caller has said the
     * selection may only span one group, taking a whole group replaces what was there rather than merging
     * into it. The job selector does not set it — a selection there may span companies.
     */
    const handleGroupToggle = (group) => {
        const itemKeys = group.items.map(item => item.key);
        const selectedHere = value[group.key] || [];
        const whollySelected = itemKeys.length > 0 && itemKeys.every(key => selectedHere.includes(key));

        if (whollySelected) {
            const newValue = {...value};
            delete newValue[group.key];
            onChange(newValue);
            return;
        }
        onChange(singleGroup ? {[group.key]: itemKeys} : {...value, [group.key]: itemKeys});
    };

    /*
     * Back to no selection at all.
     *
     * Closes the menu for a single-select, which is what picking an item does, and leaves it open for a
     * multi-select, which is also what picking an item does — clearing is the same kind of act as choosing,
     * so it behaves the same way.
     */
    const clearSelection = () => {
        onChange({});
        if (!isMulti) setOpen(false);
    };

    const openMenu = () => { if (!disabled) setOpen(true); };

    const menuItems = [];

    /*
     * The row that clears the selection, labelled with whatever the field shows when nothing is selected.
     *
     * Without it the only way back was to click the selected item a second time — the deselect branch in
     * handleItemClick — which nothing on screen mentions. So the selector was a one-way door: pick a job and
     * the aggregate view is unreachable for the rest of the session. Reported as the All Jobs option
     * disappearing on selecting a job, which is what it looked like: those words live in the closed field
     * and were never in the menu, so they read as an option that had been removed.
     *
     * First in the list, above the groups, because it is the widest scope and it is where a reader looking
     * for "show me everything again" will look. Marked as the current choice when nothing is selected, on
     * the same terms as an item, so the menu always says where you are rather than only what you could pick.
     *
     * Suppressed when the caller has no such state to offer — SelectUserDialog passes an empty
     * noSelectionText, and a dialog that needs a user chosen has nothing to say about choosing none.
     */
    if (noSelectionText) {
        const nothingSelected = selectedItems.length === 0;
        menuItems.push(
            <MenuItem
                key="__no_selection__"
                onClick={clearSelection}
                selected={nothingSelected}
                sx={{
                    py: 0.75,
                    /*
                     * The selected state is the gold label and nothing else.
                     *
                     * MUI fills Mui-selected with a tint of the palette's primary, which against this menu's
                     * #3A3E3F comes out as a solid gold block — with the label's own white on top of it, so
                     * the row read as an empty yellow bar. Nothing else in this menu is filled, either: the
                     * items and the group headers both show state by going gold. The class is kept for what
                     * it means rather than for what it paints.
                     */
                    '&.Mui-selected': {backgroundColor: 'transparent'},
                    '&.Mui-selected:hover': {backgroundColor: 'rgba(255,197,64,0.08)'},
                }}
            >
                {/*
                  * A box of its own for the widest scope, ticked while that scope is in force.
                  *
                  * Asked for as 'when All Jobs is selected the bottom check boxes should be all checked'.
                  * The jobs' own boxes are deliberately left alone: an empty selection is not the same state
                  * as every job ticked, and the difference is one a reader acts on. An empty selection
                  * follows the portal — a job onboarded tomorrow is in scope without anyone revisiting this
                  * menu — where a list of ticks is frozen at what was ticked. The export says which of the
                  * two it was in its own filename for that reason. Ticking all the boxes would also leave
                  * unticking one of them meaning something invisible: an implicit 'everything' silently
                  * becoming an explicit list of the rest.
                  *
                  * So the state gets a tick, in the same column and the same gold as the others, rather than
                  * being spelled out across boxes that mean something else. Nothing is stopped from
                  * bubbling: the row's own click is what this box is for.
                  */}
                {isMulti && (
                    <Checkbox
                        sx={{color: '#FFC540', p: 0, mr: 1, '&.Mui-checked': {color: '#FFC540'}}}
                        size="small"
                        checked={nothingSelected}
                        inputProps={{'aria-label': noSelectionText}}
                    />
                )}
                <ListItemText
                    primary={noSelectionText}
                    sx={{'& .MuiTypography-root': {fontSize: 13, color: nothingSelected ? '#FFC540' : '#FFFFFF', fontFamily: 'Poppins'}}}
                />
            </MenuItem>
        );
    }
    groups.forEach((group) => {
        const isExpanded = isGroupExpanded(group.key);
        /*
         * The three states of a group's own checkbox: whole, part, none.
         *
         * Derived from the items rather than held, so it cannot fall out of step with them — unticking one
         * job under a fully-ticked company leaves the header box indeterminate on the next render without
         * anything having to say so.
         */
        const groupItemKeys = group.items.map(item => item.key);
        const selectedInGroup = value[group.key] || [];
        const wholeGroupSelected = groupItemKeys.length > 0 && groupItemKeys.every(key => selectedInGroup.includes(key));
        const partOfGroupSelected = !wholeGroupSelected && groupItemKeys.some(key => selectedInGroup.includes(key));
        menuItems.push(
            <MenuItem
                key={`hdr-${group.key}`}
                onClick={() => toggleGroup(group.key)}
                sx={{
                    backgroundColor: '#3A3E3F',
                    color: '#FFC540',
                    fontFamily: 'Poppins',
                    fontSize: 11,
                    lineHeight: '32px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    userSelect: 'none',
                    '&:hover': {backgroundColor: 'rgba(255,197,64,0.08)'},
                }}
            >
                <Box sx={{display: 'flex', alignItems: 'center', minWidth: 0}}>
                    {/*
                      * The company's own checkbox, and the one place in this menu where a click has to be
                      * stopped from reaching the row it sits in: the row toggles expansion, so without this
                      * ticking a company would also fold its jobs out of sight. The label beside it keeps
                      * that behaviour — the two halves of the row do the two different things a reader
                      * expects of them.
                      *
                      * Given its own accessible name because the row's text says 'Brook Industries (1)',
                      * which describes the group and not what the box does to it.
                      */}
                    {isMulti && (
                        <Checkbox
                            sx={{color: '#FFC540', p: 0, mr: 1, '&.Mui-checked': {color: '#FFC540'}, '&.MuiCheckbox-indeterminate': {color: '#FFC540'}}}
                            size="small"
                            checked={wholeGroupSelected}
                            indeterminate={partOfGroupSelected}
                            inputProps={{'aria-label': `Select all jobs for ${group.label}`}}
                            onClick={(event) => { event.stopPropagation(); handleGroupToggle(group); }}
                        />
                    )}
                    <span>{group.label} ({group.items.length})</span>
                </Box>
                {groups.length > 1 && (isExpanded ? <ExpandLess sx={{fontSize: 16}}/> : <ExpandMore sx={{fontSize: 16}}/>)}
            </MenuItem>
        );
        if (isExpanded) {
            group.items.forEach((item) => {
                const isSelected = (value[group.key] || []).includes(item.key);
                menuItems.push(
                    <MenuItem
                        key={`${group.key}-${item.key}-${item.label}`}
                        onClick={() => handleItemClick(group.key, item.key)}
                        sx={{pl: 4, py: 0.75}}
                    >
                        {isMulti && (
                            <ListItemIcon sx={{minWidth: 32}}>
                                <Checkbox
                                    sx={{color: '#FFC540', p: 0, '&.Mui-checked': {color: '#FFC540'}}}
                                    size="small"
                                    checked={isSelected}
                                    inputProps={{'aria-label': `Select ${item.label}`}}
                                />
                            </ListItemIcon>
                        )}
                        {renderItem ? renderItem(item, group.key, isSelected) : (
                            <ListItemText
                                primary={item.label}
                                sx={{'& .MuiTypography-root': {fontSize: 13, color: isSelected ? '#FFC540' : '#FFFFFF', fontFamily: 'Poppins'}}}
                            />
                        )}
                    </MenuItem>
                );
            });
        }
    });

    return (
        <>
            <TextField
                ref={anchorRef}
                label={title}
                value={displayText}
                disabled={disabled}
                size={isSmall ? 'small' : 'medium'}
                onClick={openMenu}
                onKeyDown={(e) => { if (!disabled && (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown')) { e.preventDefault(); setOpen(true); } }}
                InputProps={{
                    readOnly: true,
                    endAdornment: <ExpandMore sx={{color: disabled ? 'rgba(255,255,255,0.5)' : '#FFFFFF', pointerEvents: 'none'}}/>,
                }}
                inputProps={{
                    role: 'combobox',
                    'aria-haspopup': 'listbox',
                    'aria-expanded': open,
                    'aria-disabled': disabled,
                    size: Math.max(1, displayText.length),
                    style: {cursor: disabled ? 'default' : 'pointer', caretColor: 'transparent'},
                }}
                sx={{
                    minWidth,
                    "& .MuiOutlinedInput-root": {
                        color: '#ffffff !important',
                        cursor: disabled ? 'default' : 'pointer',
                        "& fieldset": {border: "1px solid #C7CCD0 !important", borderRadius: '8px !important'},
                    },
                    "& .MuiInputLabel-root": {color: '#FFFFFF'},
                    "& .MuiInputLabel-root.Mui-focused": {color: '#FFFFFF'},
                    "& .MuiInputLabel-root.Mui-disabled": {color: 'rgba(255,255,255,0.5)'},
                    "& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input": {WebkitTextFillColor: 'rgba(255,255,255,0.5) !important', color: 'rgba(255,255,255,0.5) !important'},
                    "& .MuiOutlinedInput-root.Mui-disabled fieldset": {borderColor: 'rgba(199,204,208,0.5) !important'},
                    ...(isSmall ? {
                        "& .MuiOutlinedInput-input": {fontSize: 14, fontFamily: 'Poppins'},
                        "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {fontSize: 14},
                    } : {}),
                }}
            />
            <Menu
                anchorEl={anchorRef.current}
                open={open}
                onClose={() => setOpen(false)}
                anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
                transformOrigin={{vertical: 'top', horizontal: 'left'}}
                MenuListProps={{sx: {py: 0}}}
                slotProps={{
                    paper: {
                        sx: {
                            backgroundColor: '#3A3E3F',
                            maxHeight: 320,
                            minWidth: anchorRef.current?.clientWidth ?? minWidth,
                        }
                    }
                }}
            >
                {menuItems}
            </Menu>
        </>
    );
};